import { useServicesContext } from "@/modules/core/services/services.context"
import { CommentEntity } from "@/modules/social/entities/socialEntity"
import { socialKeys } from "@/modules/social/gateway/socialKeys"
import { useSuspenseInfiniteQuery } from "@tanstack/react-query"

export const useSocialComments = (socialPostId: string) => {
  const { socialApi } = useServicesContext()

  return useSuspenseInfiniteQuery({
    queryKey: socialKeys.comments(socialPostId),
    queryFn: async ({ pageParam }) => {
      const dto = await socialApi.getComments(socialPostId, pageParam, 20)
      return {
        ...dto,
        content: dto.content.map((commentDto) => CommentEntity.fromDto(commentDto)),
      }
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      if (lastPage.last) return undefined
      return lastPage.page + 1
    },
  })
}
